/**
 * round {number} to a maximum precision of {decimalPlaces}
 * @param number
 * @param decimalPlaces
 */
export function roundToDecimal(number: number, decimalPlaces: number) {
  const divisor = Math.pow(10, decimalPlaces);

  return Math.round((number + Number.EPSILON) * divisor) / divisor;
}
